import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mdrlAPI } from '@api/modules/mdrl';
import { optnAPI } from '@api/modules/optn';
import { suppAPI } from '@api/modules/supp';
import { imgeAPI } from '@api/modules/imge';
import { colrAPI } from '@api/modules/colr.js';
import addHeader from '@/views/component/addHeader.vue';
import helper from '@assets/js/helper';
import inputUser from '@/views/component/inputUser.vue';
import imgPopover from '@/views/component/imgPopover.vue';
import MdrlImport from './Componet/MdrlImport.vue';
import { fillZero as _fillZero } from '@assets/js/StringUtils';
import { cloneDeep } from 'lodash';
export default {
  name: 'mdrlAddMain',
  components: {
    addHeader: addHeader,
    inputUser: inputUser,
    imgPopover: imgPopover,
    MdrlImport: MdrlImport
  },
  data: function data() {
    return {
      mdrlForm: {
        mdrl_no: '',
        mdrl_name: '',
        mdrl_type: 1,
        mdrl_spec: '',
        mdrl_weight: '',
        mdrl_unit: '',
        imge_id: null,
        imge_url: '',
        imge_urlO: '',
        mdrl_stock_limit: 0,
        mdrl_remark: '',
        cust_id: null,
        cust_name: null,
        supp_id: '',
        user_id: null,
        stff_id: null,
        dept_id: null,
        status: 0,
        key: 0,
        mdrl_info_list: [{
          supp_id: null,
          mdrl_price: 0,
          mdrl_info_checked: true,
          key: 0
        }],
        mdrl_no_suffix: '',
        no_mdrl_price: 0,
        mdrl_price: 0
      },
      warningTitle: '',
      uploadUrl: helper.modePrepend(imgeAPI.uploadImage),
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400
      },
      mdrlType: [{
        id: 1,
        label: '主材料'
      }, {
        id: 2,
        label: '辅材料'
      }, {
        id: 3,
        label: '其他'
      }],
      mainMaterial: [{
        id: 0,
        label: 'P20精料'
      }, {
        id: 1,
        label: 'P20毛料'
      }, {
        id: 2,
        label: 'P20光料'
      }, {
        id: 3,
        label: '45#精料'
      }, {
        id: 4,
        label: '45#光料'
      }, {
        id: 5,
        label: '45#毛料'
      }, {
        id: 6,
        label: '738H精料'
      }, {
        id: 7,
        label: '718H精料'
      }],
      minorMaterial: [{
        id: 0,
        label: 'SUJ2'
      }, {
        id: 1,
        label: '20CR'
      }, {
        id: 2,
        label: '镀铜'
      }, {
        id: 3,
        label: '45#'
      }, {
        id: 4,
        label: 'STD'
      }],
      mdrlTypeGroupOpt: [],
      suppType: [],
      optnColorList: [],
      checkedIndex: 0,
      MdrlFlag: false,
      CustTitle: '添加物料专属客户',
      imgTypeFlag: true,
      stffForm: {},
      mdrlUnitList: [{
        id: 1,
        label: '件'
      }, {
        id: 2,
        label: '个'
      }, {
        id: 3,
        label: '支'
      }, {
        id: 4,
        label: '条'
      }]
    };
  },
  watch: {},
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.getMdrlType();
      this.getSuppsList();
    },
    fillZero: function fillZero(val) {
      var _this = this;

      mdrlAPI.getMdrlNoTopMax({
        mdrlNo: val
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code !== 0) {
          _this.mdrlForm.mdrl_no_suffix = '00001';
          return;
        }

        _this.mdrlForm.mdrl_no_suffix = _fillZero(5, data.data.mdrlNo);
      });
    },
    //提交表单
    submit: function submit(formName) {
      var _this2 = this;

      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$refs[formName].validate(function (valid) {
          if (valid) {
            _this2.saveInfo();
          } else {
            console.log('error submit!');

            _this2.$message.warning('请把必填内容填写完整！');

            return false;
          }
        });
      });
    },
    // 保存
    saveInfo: function saveInfo() {
      var _this3 = this;

      var mdrlForm = cloneDeep(this.mdrlForm);

      for (var i in mdrlForm.mdrl_info_list) {
        if (mdrlForm.mdrl_info_list[i].mdrl_info_checked) {
          mdrlForm.mdrl_info_list[i].mdrl_info_checked = 1;
        } else if (!mdrlForm.mdrl_info_list[i].mdrl_info_checked) {
          mdrlForm.mdrl_info_list[i].mdrl_info_checked = 0;
        }
      }

      mdrlForm.mdrl_no = mdrlForm.mdrl_no.toLocaleUpperCase() + mdrlForm.mdrl_no_suffix;
      post(mdrlAPI.addMdrl, mdrlForm).then(function (res) {
        if (res.data.code === 0) {
          _this3.$message({
            type: 'success',
            message: '保存成功'
          });

          var permId = _this3.$route.query.perm_id;

          _this3.jump("/mdrl_edit?perm_id=".concat(permId, "&form_id=").concat(res.data.data.form_id));

          _this3.warningTitle = false;

          _this3.resetForm('mdrlForm');
        } else {
          _this3.$message.error(res.data.msg);
        }
      });
    },
    //取消
    cancel: function cancel() {
      var _this4 = this;

      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this4.resetForm('mdrlForm');

        _this4.$router.go(-1);

        _this4.$message({
          type: 'info',
          message: '已取消新增!'
        });
      });
    },
    //打开专属客户弹窗
    custImport: function custImport() {
      this.MdrlFlag = true;
    },
    //关闭专属客户弹窗
    custCancel: function custCancel() {
      this.MdrlFlag = false;
    },
    // custID子传父值
    custID: function custID(val) {
      if (val) {
        this.mdrlForm.cust_id = val.join(',');
      } else {
        this.mdrlForm.cust_id = null;
      }
    },
    custName: function custName(val) {
      if (val) {
        this.mdrlForm.cust_name = val.join(',');
      } else {
        this.mdrlForm.cust_name = null;
      }
    },
    // 取消
    cancelCust: function cancelCust() {
      this.MdrlFlag = false;
    },
    // 新增字表数据
    addRow: function addRow() {
      var temp = {};

      if (this.mdrlForm.supp_id) {
        temp.supp_id = this.mdrlForm.supp_id;
      } else {
        temp.supp_id = null;
      }

      if (this.mdrlForm.mdrl_price) {
        temp.mdrl_price = this.mdrlForm.mdrl_price;
      } else {
        temp.mdrl_price = '0.0000';
      }

      temp.mdrl_info_checked = false;
      temp.key = this.mdrlForm.mdrl_info_list.length;
      this.mdrlForm.mdrl_info_list.push(temp);
    },
    // 删除子表数据
    deleteClick: function deleteClick(val) {
      if (this.mdrlForm.mdrl_info_list.length <= 1) {
        this.$message({
          type: 'warning',
          message: '至少保留一条'
        });
      } else {
        var flag = false;

        if (this.mdrlForm.mdrl_info_list[val.key].mdrl_info_checked) {
          flag = true;
        }

        this.mdrlForm.mdrl_info_list.splice(val.key, 1);

        for (var i in this.mdrlForm.mdrl_info_list) {
          this.mdrlForm.mdrl_info_list[i].key = i;
        }

        if (flag) {
          this.mdrlForm.mdrl_info_list[0].mdrl_info_checked = true;
          this.checkedIndex = 0;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[0].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[0].supp_id;
        } else {
          for (var _i in this.mdrlForm.mdrl_info_list) {
            if (this.mdrlForm.mdrl_info_list[_i].mdrl_info_checked) {
              this.checkedIndex = _i;
            }
          }
        }
      }
    },
    // 狭隘拉框更换
    selectChange: function selectChange(val) {
      this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val].supp_id;
    },
    // 价格变动
    inputChange: function inputChange(index) {
      this.mdrlForm.mdrl_info_list[index].mdrl_price = helper.keepTNum1(this.mdrlForm.mdrl_info_list[index].mdrl_price);
      this.mdrlForm.mdrl_price = helper.haveFour(this.mdrlForm.mdrl_info_list[index].mdrl_price);
    },
    // 更换复选框
    checkboxChange: function checkboxChange(val, val1) {
      if (val.mdrl_info_checked) {
        var flag = 0;

        for (var i in this.mdrlForm.mdrl_info_list) {
          if (this.mdrlForm.mdrl_info_list[i].mdrl_info_checked) {
            flag += 1;
          }
        }

        if (flag > 1) {
          var ind = JSON.parse(JSON.stringify(this.checkedIndex));
          this.mdrlForm.mdrl_info_list[ind].mdrl_info_checked = false;
          this.checkedIndex = val1;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[val1].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val1].supp_id;
        } else {
          this.checkedIndex = val1;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[val1].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val1].supp_id;
        }
      } else {
        var _flag = 0;

        for (var _i2 in this.mdrlForm.mdrl_info_list) {
          if (this.mdrlForm.mdrl_info_list[_i2].mdrl_info_checked) {
            _flag += 1;
          }
        }

        if (_flag === 0) {
          this.mdrlForm.mdrl_info_list[val1].mdrl_info_checked = true;
          this.mdrlForm.mdrl_price = this.mdrlForm.mdrl_info_list[val1].mdrl_price;
          this.mdrlForm.supp_id = this.mdrlForm.mdrl_info_list[val1].supp_id;
          this.checkedIndex = val1;
        }
      }
    },
    // 商户下拉框下拉
    suppChange: function suppChange() {
      this.getSuppsList();
    },
    // 获取单位
    getMdrlType: function getMdrlType() {
      var _this5 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10005
      }).then(function (res) {
        if (res.data.code === 0) {
          _this5.mdrlTypeGroupOpt = res.data.data;
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this5.$message({
            message: mg,
            type: tp
          });
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this5.$message({
          message: mg,
          type: tp
        });
      });
    },
    // 获取供应商信息
    getSuppsList: function getSuppsList() {
      var _this6 = this;

      get(suppAPI.getSuppsV1).then(function (res) {
        if (res.data.code === 0) {
          _this6.suppType = res.data.data;
        }
      });
    },
    // 成功上传
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      if (res.code === 0) {
        if (this.imgTypeFlag) return this.$message.warning('仅支持jpg、png、jpeg格式的图片');
        var updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        var urlEng = JSON.parse(JSON.stringify(res.data.imge_url));
        this.mdrlForm.imge_id = res.data.imge_id;
        this.mdrlForm.imge_url = this.helper.picUrl(urlEng, 's', updateTime);
        this.mdrlForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 上传头像前
    beforeAvatarUpload: function beforeAvatarUpload(res) {
      this.imgTypeFlag = false;
      var str = res.name.substr(res.name.indexOf('.') + 1, res.name.length);
      var imgTypeList = ['jpg', 'png', 'jpeg'];
      if (imgTypeList.indexOf(str) === -1) this.imgTypeFlag = true;
    },
    //表单重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.mdrlForm.imge_url = null;
      this.mdrlForm.imge_urlO = null;
      this.mdrlForm.imge_id = null;
    }
  }
};